import React from 'react';
import { useTranslation } from 'react-i18next';
import { SettingsToggleRow } from '../../../../../../components/design-system/common/SettingsPanel';
import { Card } from './Card';

interface GroutCardV3Props {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

/**
 * Surface products: whether shoppers may change this product's grout in the
 * visualizer (grout v2). Takes effect where the vendor turned the grout
 * feature on (Configurations → General → Grout).
 */
export const GroutCardV3: React.FC<GroutCardV3Props> = ({ checked, onCheckedChange }) => {
  const { t } = useTranslation();

  return (
    <Card title={t('PAGES.NEW_PRODUCT.V3.GROUT.TITLE', 'Grout')}>
      <SettingsToggleRow
        id="product-grout-editable"
        label={t('PAGES.NEW_PRODUCT.V3.GROUT.EDITABLE', 'Shoppers can change the grout')}
        description={t(
          'PAGES.NEW_PRODUCT.V3.GROUT.EDITABLE_DESC',
          'In the visualizer, when grout is turned on in your settings.'
        )}
        checked={checked}
        onCheckedChange={onCheckedChange}
      />
    </Card>
  );
};
